import React from 'react'
import PropTypes from 'prop-types'

import lang from '@/lang'
import { UserAuthDialog } from '@/components/dialogs'
import { ROUTES } from 'modules/account/constants'
import { makeStyles } from '@mui/styles'
import TextLink from '@/components/dialogs/text-link'

const ApproveWrapper = ({ title, showLoginLink, children }) => {
  const classes = useStyles()

  return (
    <UserAuthDialog title={title} >
      {children}
      {showLoginLink && <span className={classes.footerLink}>
        <TextLink
          links={[{ label: lang.registerLoginLink, target: ROUTES.login }]}
        />
      </span>}
    </UserAuthDialog>
  )
}

const useStyles = makeStyles(() => ({
  footerLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    '& > span': {
      '& a': {
        marginLeft: 0,
      },
    },
  },
}))

ApproveWrapper.propTypes = {
  title: PropTypes.string,
  showLoginLink: PropTypes.bool,
}

ApproveWrapper.defaultProps = {
  showLoginLink: false,
}

export default ApproveWrapper
